import { render } from "./UploadedFiles.vue?vue&type=template&id=45760600&scoped=true"
import script from "./UploadedFiles.vue?vue&type=script&lang=js"
export * from "./UploadedFiles.vue?vue&type=script&lang=js"

import "./UploadedFiles.vue?vue&type=style&index=0&id=45760600&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45760600"]])

export default __exports__